module.exports = __webpack_public_path__ + "img/regenera.b6b951a8.png";